
import { Component, Vue } from "vue-property-decorator";
import {shortenText} from "@/utils";
import { ref } from 'vue';
@Component({
  methods: {shortenText},
  components: {

  },
})
export default class Transactions extends Vue {
  public wikiFrame = ref(null)
  public handleLoad() {
    // Получаем DOM-элемент через this.$refs
    const iframe = this.$refs.wikiFrame as HTMLIFrameElement;
    if (!iframe || !iframe.contentWindow) return;

    const message = {
      cmd: "hideLogo",
    };

    iframe.contentWindow.postMessage(
        message,
        "https://wiki.dexfreedom.com"
    );
  }
}
